export default __webpack_public_path__ + "static/media/icon_trash_red_outline.1f0878c6.svg";